import { List, styled } from "@mui/material";

export const Styled = {
    OrderedList: styled(List)`
        list-style: decimal;
        & .MuiList-root {
            border: none;

            & li {
                &:hover {
                    background: none;
                }
            }
            & ul {
                &:hover {
                    background: none;
                }
            }
        }
    `,
    UnorderedList: styled(List)`
        list-style: disc;
        margin-left: 2px;
        margin-bottom: 20px;

        & .MuiListItem-root {
            display: list-item;
            font-weight: 400;
            font-size: 14px;
        }
    `,
};
